/**
 * @description
 * 充值协议
 */

import { createNamespacedHelpers } from "vuex-composition-helpers"
import { AppleGiftCardActions } from "../../store/apple-gift-card/actions"
import { AppleGiftCardGetters } from "../../store/apple-gift-card/getters"
import { AppleGiftCardMutations } from "../../store/apple-gift-card/mutations"
import { AppleGiftCardState } from "../../store/apple-gift-card/state"
import MUTATION_TYPES from "../../store/apple-gift-card/mutation-types"

const { useMutations, useState } = createNamespacedHelpers<
  AppleGiftCardState,
  AppleGiftCardGetters,
  AppleGiftCardActions,
  AppleGiftCardMutations
>("appleGiftCard")

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () => {
  const { agreeChecked, hideWarn, configInfo } = useState(["agreeChecked", "hideWarn", "configInfo"])
  const mutations = useMutations([MUTATION_TYPES.SET_AGREE_CHECKED])

  const changeAgreeChecked = () => {
    mutations[MUTATION_TYPES.SET_AGREE_CHECKED](!agreeChecked.value)
  }

  return { agreeChecked, hideWarn, configInfo, changeAgreeChecked }
}
